import useSWR from 'swr';

const fetcher = () => null;

const useSWRStore = <T, K>(key: string | null, options?: K) =>
  useSWR<T | null>(key, fetcher, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnMount: false,
    revalidateOnReconnect: false,
    refreshWhenOffline: false,
    refreshWhenHidden: false,
    refreshInterval: 0,
    ...(options ?? {}),
  });

export default useSWRStore;
